module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_campaign')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addCompany
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_campaign')))])]), _vm._v(" "), _c('span', {
    staticClass: "section-left-xxs"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.addCompanyCampaign
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_add_company_campaign')))])]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_title_message')) + " ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_send_message')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_users_number')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_send_by_email')))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_send_by_notification')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.campaigns), function(company) {
    return _c('tr', [_c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_title_message')
      }
    }, [_vm._v(_vm._s(company.title))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_send_message')
      }
    }, [_vm._v(_vm._s(company.text))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_users_number')
      }
    }, [_vm._v(_vm._s(company.countUser))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_send_by_email')
      }
    }, [_vm._v(_vm._s(company.sentByEmail ? _vm.locale.t('label_yes') : _vm.locale.t('label_no')))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_send_by_notification')
      }
    }, [_vm._v(_vm._s(company.sentByPush ? _vm.locale.t('label_yes') : _vm.locale.t('label_no')))])])
  }), 0)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55b3eefc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Campaign/CampaignList.vue
// module id = 785
// module chunks = 0